import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import {
  ICredentialsPickitErrors,
  ICredentialsPickitPayload,
} from "../../interfaces/configuration";
import { IValidation } from "../../interfaces/form";
import { ICredentialsModal } from "../../interfaces/modal";
import { ERRORS_MESSAGES } from "../../utils/constants";
import { validateInputs } from "../../utils/inputValidations";
import ModalBase from "./ModalBase";
import CredentialsPickit from "../forms/CredentialsPickit";
import ConfirmChangesCredentials from "../configuration/ConfirmChangesCredentials";
import GenericForm from "../GenericForm";

const { pickitTokenRequired, pickitApikeyRequired } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "token",
    type: "required",
    message: pickitTokenRequired,
  },
  {
    id: "apikey",
    type: "required",
    message: pickitApikeyRequired,
  },
];

const CredentialsPickitModal = ({
  open,
  onClose,
  carrier,
  handleChangeOfConfig,
}: ICredentialsModal) => {
  const credentials = (carrier.credentials ||
    {}) as ICredentialsPickitPayload;

  const [values, setValues] = useState(credentials);
  const [errors, setErrors] = useState({} as ICredentialsPickitErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(values, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleChangeOfConfig({
        _id: carrier._id,
        name: carrier.name,
        disabled: carrier.disabled,
        credentials: values,
      });
      onClose();
    }
  };

  return (
    <ModalBase open={open} handleClose={onClose} maxWidth="md">
      <Grid container>
        <Typography className="f-s-18 m-b-10">
          Ingresa los datos de tu contrato con Pickit
        </Typography>
        <GenericForm onSubmit={handleSubmit}>
          <CredentialsPickit
            values={values}
            setValues={setValues}
            errors={errors}
          />
        </GenericForm>

        <ConfirmChangesCredentials
          onClose={onClose}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </ModalBase>
  );
};

export default CredentialsPickitModal;
